import { Chart } from 'react-google-charts';
import useGetActivities from '../hooks/useGetActivities';
import { useEffect, useState } from 'react';
import { useGetChartData } from '../hooks/useGetChartData';
import Icon from './Icon';
import Dropdown_dynamic from './dropdown/dropdown_dynamic';

export const options = () => ({
  //legend: {position: 'none'},
  backgroundColor: 'transparent',
  chartArea: { width: '100%', height: '80%' },
  curveType: 'function',
  hAxis: {
    gridlines: { color: 'transparent', minSpacing: 20 },
  },
});
export const ActivityCharts = ({ collectionAddress, itemId }) => {
  const conditions = [
    { field: 'eventType', operator: '=', value: 'bid' },
    { field: 'collectionAddress', operator: '=', value: collectionAddress },
  ];
  if (itemId) conditions.push({ field: 'itemId', operator: '=', value: itemId });
  const { data: swr } = useGetChartData('itemactivities', 'price', conditions, 30);
  const [data, setData] = useState([]);

  const { data: results } = swr || {};

  useEffect(() => {
    if (!results) return;
    const newData = [['Date', 'Floor Price', 'Max Price', 'Volume']];
    results.map((r) => {
      const { date, floor, max, volume } = r;
      newData.push([date, floor, max, volume]); //.substr(0,16).replace('T', ' ')
    });
    setData(newData);
  }, [results]);
  return (
    <div className={'flex w-full flex-wrap overflow-x-auto overflow-y-hidden md:flex-nowrap'}>
      <div className={'w-full'}>
        <h1 className={'ml-2 mb-2 font-bold'}>Floor</h1>
        <div className={'origin-bottom dark:invert'}>
          {data.length > 0 && (
            <Chart
              chartType='LineChart'
              width='100%'
              height='400px'
              data={data}
              options={options()}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export const SellChart = ({ collectionAddress, itemId }) => {
  const conditions = [
    { field: 'eventType', operator: '=', value: 'sale' },
    { field: 'collectionAddress', operator: '=', value: collectionAddress },
  ];
  if (itemId) conditions.push({ field: 'itemId', operator: '=', value: itemId });
  const { data: swr } = useGetChartData('itemactivities', 'price', conditions, 30);
  const [data, setData] = useState([]);

  const { data: results } = swr || {};

  useEffect(() => {
    if (!results) return;
    const newData = [['Date', 'Sales']];
    results.map((r) => {
      const { date, amount } = r;
      newData.push([date, amount]); //.substr(0,16).replace('T', ' ')
    });
    setData(newData);
  }, [results]);
  return (
    <div className={'flex w-full flex-wrap overflow-x-auto overflow-y-hidden md:flex-nowrap'}>
      <div className={'w-full'}>
        <h1 className={'ml-2 mb-2 font-bold'}>Sales</h1>
        <div className={'origin-bottom dark:invert'}>
          <Chart
            chartType='LineChart'
            width='100%'
            height='400px'
            data={data}
            options={options()}
          />
        </div>
      </div>
    </div>
  );
};

const chartIcons = {
  LineChart: {
    tooltip: 'Line Chart',
    icon: () => (
      <svg
        stroke='currentColor'
        fill='currentColor'
        strokeWidth='0'
        viewBox='0 0 1024 1024'
        height='1em'
        width='1em'
        xmlns='http://www.w3.org/2000/svg'
      >
        <path d='M888 792H200V168c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v688c0 4.4 3.6 8 8 8h752c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM305.8 637.7c3.1 3.1 8.1 3.1 11.3 0l138.3-137.6L583 628.5c3.1 3.1 8.2 3.1 11.3 0l275.4-275.3c3.1-3.1 3.1-8.2 0-11.3l-39.6-39.6a8.03 8.03 0 0 0-11.3 0l-230 229.9L461.4 404a8.03 8.03 0 0 0-11.3 0L266.3 586.7a8.03 8.03 0 0 0 0 11.3l39.5 39.7z' />
      </svg>
    ),
  },
  ScatterChart: {
    tooltip: 'Scatter Chart',
    icon: () => (
      <svg
        stroke='currentColor'
        fill='currentColor'
        strokeWidth='0'
        viewBox='0 0 1024 1024'
        height='1em'
        width='1em'
        xmlns='http://www.w3.org/2000/svg'
      >
        <path d='M888 792H200V168c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v688c0 4.4 3.6 8 8 8h752c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM288 604a64 64 0 1 0 128 0 64 64 0 1 0-128 0zm118-224a48 48 0 1 0 96 0 48 48 0 1 0-96 0zm158 228a96 96 0 1 0 192 0 96 96 0 1 0-192 0zm148-314a56 56 0 1 0 112 0 56 56 0 1 0-112 0z' />
      </svg>
    ),
  },
};

export const ChartContainer = ({ children, className }) => {
  return (
    <div
      className={
        className +
        ' flex h-full w-full flex-wrap overflow-x-auto overflow-y-hidden rounded-lg border border-jacarta-200 p-4 dark:border-jacarta-600 md:flex-nowrap'
      }
    >
      {children}
    </div>
  );
};
const dayCountToText = (count) => {
  if (count >= 30) {
    const c = Math.floor(count / 30);
    return `${Math.floor(count / 30)}  ${c > 1 ? 'Months' : 'Month'}`;
  }
  if (count >= 14) {
    return `${Math.floor(count / 7)}  Weeks`;
  }
  return `${count}  Days`;
};

export const ChartComponent = ({ statsData }) => {
  const [selectedIndex, setSelectedIndex] = useState(0);
  const {
    data: results,
    description,
    name,
    daysBefore,
    fieldsToDraw,
    chartTypes,
  } = statsData[selectedIndex];
  const [data, setData] = useState([]);
  const [chartType, setChartType] = useState(chartTypes ? chartTypes[0] : 'LineChart');

  useEffect(() => {
    if (!results) return;
    const newData = [['Date', ...Object.values(fieldsToDraw)]];
    results.map((r) => {
      const dataToPush = [r.date];
      Object.keys(fieldsToDraw).forEach((key) => {
        dataToPush.push(r[key]);
      });
      newData.push(dataToPush); //.substr(0,16).replace('T', ' ')
    });
    setData(newData);
  }, [results]);
  return (
    <ChartContainer>
      <div className={'w-full'}>
        <div className={'relative flex'}>
          <div>
            <h1 className={'ml-0 mb-2 font-bold'}>{name}</h1>
            <p className='mt-5 overflow-hidden text-ellipsis whitespace-nowrap break-keep md:mt-0'>
              {description} <br /> Last {daysBefore} days
            </p>
          </div>
          {
            <div
              className={
                'rounded-xl mt-2 ml-auto mb-8 inline-flex h-fit items-center justify-center border border-jacarta-100 bg-white dark:border-jacarta-600 dark:bg-jacarta-800'
              }
            >
              {chartTypes.map((t) => {
                const icon = chartIcons[t];
                return (
                  <div
                    key={`${t}type`}
                    onClick={() => setChartType(t)}
                    className={`${
                      t == chartType && 'bg-jacarta-100 dark:bg-jacarta-800'
                    } first:rounded-l-xl last:rounded-r-xl border-r border-jacarta-100 py-2 px-4 text-center hover:cursor-pointer hover:shadow-md dark:border-jacarta-600 dark:bg-jacarta-500`}
                  >
                    {icon && <icon.icon />}
                  </div>
                );
              })}
            </div>
          }
          <div className='ml-2'>
            <Dropdown_dynamic
              items={statsData.map((d, i) => ({
                id: i,
                text: dayCountToText(d.daysBefore),
              }))}
              value={{
                id: statsData[selectedIndex].daysBefore,
                text: dayCountToText(statsData[selectedIndex].daysBefore),
              }}
              onSelect={(val) => {
                setSelectedIndex(val.id);
              }}
              className={'ml-auto mt-4 !min-w-[60px] pl-2 md:mt-1 md:pl-0'}
            />
          </div>
        </div>
        <div className={'origin-bottom dark:invert'}>
          {data.length > 1 ? (
            <Chart
              chartType={chartType}
              width='100%'
              height='400px'
              data={data}
              options={options()}
            />
          ) : (
            <p className='my-10 w-full text-center'>Stat is not available</p>
          )}
        </div>
      </div>
    </ChartContainer>
  );
};
